module.exports = __webpack_public_path__ + "img/injuryTypes.aec87446.svg";